/* ============
 * Templates Actions
 * ============
 *
 * The actions available for the Templates module.
 */

import Vue from 'vue';
import store from '@/store';
import TemplateApi from '@/api/template';

export default {
  async findAll() {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.findAll();
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.findAll.error'));
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async findById({ commit }, templateId) {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.findById(templateId);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.findById.error'));
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async search({ commit }, searchParams) {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.search(searchParams);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.search.error'));
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async create({ commit }, template) {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.create(template);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.create.error'));
      } else {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.templates.create.success'),
          time: 3,
          type: 'success',
        });
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async update({ commit }, template) {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.update(template);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.update.error'));
      } else {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.templates.update.success'),
          time: 3,
          type: 'success',
        });
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async destroy({ commit }, templateId) {
    store.dispatch('application/startLoading');
    try {
      let response = await TemplateApi.destroy(templateId);
      if (response.status !== 'success') {
        throw new Error(Vue.$i18n.t('store.templates.destroy.error'));
      }
      return Promise.resolve(response.data);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      return Promise.reject(error.message);
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/templates/actions.js